import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";


const ImageBackground = styled.div`
background-image: ${(props) => props.url};
height: 100%;
background-position: center;
background-size: cover;
}
`;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: "90vw",
    height: "70vh",
    margin: "0px auto 0px",
    display: "flex",
    backgroundColor: "#F7F7F7",
    [theme.breakpoints.down("md")]: {
      height: "60vh",
    },
    [theme.breakpoints.down("sm")]: {
      height: "80vh",
      marginBottom: "50px",
      minHeight: "650px",
    },
  },
  background: {
    height: "70vh",
    [theme.breakpoints.down("md")]: {
      height: "60vh",
    },
    [theme.breakpoints.down("sm")]: {
      height: "50vh",
      minHeight: "405px",
    },
  },
  item: {
    padding: "40px 80px",
    alignSelf: "center",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      padding: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "30vh",
      minHeight: "245px",
      display: "flex",
      alignItems: "center",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "20px",
    },

  },
  leftItem: {
    [theme.breakpoints.up("md")]: {
      borderRight: "1px solid #666666",
    },
  },
}));

export default function LeistungHero(props) {
  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.wrapper}>
        <Grid item xs={12} md={6} className={classes.background}>
          <ImageBackground url={props.imageUrl} />
        </Grid>

        <Grid item xs={12} md={6} className={classes.item}>
        <div>
          <h1 className="uppercase">{props.heading}</h1>
          {props.text.split("\n").map((text) => (
            <p>{text}</p>
          ))}
          </div>
        </Grid>
      </Grid>
    </>
  );
}
